import { render, staticRenderFns } from "./DownloadTestatorListCsv.vue?vue&type=template&id=73074b1c"
import script from "./DownloadTestatorListCsv.vue?vue&type=script&lang=js"
export * from "./DownloadTestatorListCsv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports